import { createValidator } from 'revalidate';
import { INVALID_TAX_ID } from '../constants/defaultErrorMessages';
const isValidTaxId = taxIdFormat => createValidator(message => value => {
  const validTaxFormat = new RegExp(taxIdFormat);
  if (value && !validTaxFormat.test(value)) {
    return message || INVALID_TAX_ID;
  }
  return null;
}, INVALID_TAX_ID);
export default isValidTaxId;
//# sourceMappingURL=isValidTaxId.js.map